import { useRef, useState } from "react";

import classes from "./Checkout.module.css";

const isEmpty = (value) => value.trim() === "";
const is6of7Chars = (value) =>
  value.trim().length === 6 || value.trim().length === 7;

const Checkout = (props) => {
  // One combined state slice
  // Set all to true to avoid error messages at the beginning.
  const [formInputsValidity, setFormInputsValidity] = useState({
    name: true,
    street: true,
    city: true,
    postalCode: true,
  });

  const nameInputRef = useRef();
  const streetInputRef = useRef();
  const postalCodeInputRef = useRef();
  const cityInputRef = useRef();

  // We will get event object automatically because we bind this function to the onSubmit event on the form.
  const confirmHandler = (event) => {
    event.preventDefault();

    const enteredName = nameInputRef.current.value; // Altijd current
    const enteredStreet = streetInputRef.current.value;
    const enteredPostalCode = postalCodeInputRef.current.value;
    const enteredCity = cityInputRef.current.value;

    const enteredNameIsValid = !isEmpty(enteredName);
    const enteredStreetIsValid = !isEmpty(enteredStreet);
    const enteredCityIsValid = !isEmpty(enteredCity);
    const enteredPostalCodeIsValid = is6of7Chars(enteredPostalCode);

    setFormInputsValidity({
      name: enteredNameIsValid,
      street: enteredStreetIsValid,
      city: enteredCityIsValid,
      postalCode: enteredPostalCodeIsValid,
    });

    const formIsValid =
      enteredNameIsValid &&
      enteredStreetIsValid &&
      enteredCityIsValid &&
      enteredPostalCodeIsValid;

    if (!formIsValid) {
      return;
    }

    props.onConfirm({
      achternaam: enteredName,
      straat: enteredStreet,
      woonplaats: enteredCity,
      postcode: enteredPostalCode,
    });
  };

  const nameControlClasses = `${classes.control} ${
    formInputsValidity.name ? "" : classes.invalid
  }`;
  const streetControlClasses = `${classes.control} ${
    formInputsValidity.street ? "" : classes.invalid
  }`;
  const postalCodeControlClasses = `${classes.control} ${
    formInputsValidity.postalCode ? "" : classes.invalid
  }`;
  const cityControlClasses = `${classes.control} ${
    formInputsValidity.city ? "" : classes.invalid
  }`;

  // Waarde voor htmlFor dient gelijk te zijn aan de waarde van id
  return (
    <form className={classes.form} onSubmit={confirmHandler}>
      <div className={nameControlClasses}>
        <label htmlFor="name">Achternaam</label>
        <input type="text" id="name" ref={nameInputRef} />
        {/* formInputsValidity is een object met 4 properties */}
        {!formInputsValidity.name && <p>Voer een geldige achternaam in!</p>}
      </div>
      <div className={streetControlClasses}>
        <label htmlFor="street">Straat</label>
        <input type="text" id="street" ref={streetInputRef} />
        {!formInputsValidity.street && <p>Voer een geldige straat in!</p>}
      </div>
      <div className={postalCodeControlClasses}>
        <label htmlFor="postal">Postcode</label>
        <input type="text" id="postal" ref={postalCodeInputRef} />
        {!formInputsValidity.postalCode && (
          <p>Voer een geldige postcode in (6 of 7 characters lang)!</p>
        )}
      </div>
      <div className={cityControlClasses}>
        <label htmlFor="city">Woonplaats</label>
        <input type="text" id="city" ref={cityInputRef} />
        {!formInputsValidity.city && <p>Voer een geldige woonplaats in!</p>}
      </div>
      <div className={classes.actions}>
        <button type="button" onClick={props.onCancel}>
          {/* type='button' so that it does not submit the form */}
          Annuleren
        </button>
        <button className={classes.submit}>Bevestigen</button>{" "}
        {/* Only this button will trigger this form submission and will therefore trigger the confirmHandler function */}
      </div>
    </form>
  );
};

export default Checkout;